export const globalStyle = {
  bgColor: "#F4F5F6",
  bgColorWhite: "#f0f2f7",
  bgColorBlue: "#1a284f",
  buttonColor: "linear-gradient(#3A80FB, #6A3DC1)",
  stepColor: "linear-gradient(#B4CCF7, #B4CCF7)",
  blueColor: "#3A80FB",
  curveDarkColor: "#1a284f",
  curveLightColor: "#EBF2F4",
  fontSize: 16,
  headingFontSize: 32,
  headingFontSizeSmall: 18,
  fontFamilyHeading: "Inter",
  fontFamily: "'Roboto Serif', serif",
  fontFamilyParagraph: "Rubik",
  fontFamilyButton: "'Roboto Serif', serif",
  borderRadius: 4,
  marginBetween: 1.5,
};
